import { z } from 'zod';

import { useForm } from '@pletly/ui';

const formSchema = z.object({
	name: z.string().min(1).max(200),
	postsScreening: z.undefined().or(z.boolean()),
});

type Options = {
	defaultValues?: z.infer<typeof formSchema>;
};

export const useTeamForm = (options?: Options) => {
	const formMethods = useForm(formSchema, options);

	return formMethods;
};

export type TeamFormMethods = ReturnType<typeof useTeamForm>;
